import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import { Easing } from '@tweenjs/tween.js';
import { tEasing } from '../../../Utility/Types';
import ElementComponent from '../../../Component/UI/Element';
import TransformComponent from '../../../Component/Transform';
import Point from '../../../Utility/Point';
import { tVector4 } from '../../../Utility/ArrayHelper';
import { delay } from 'Utility/Task/TaskQueue';
import Renderable from 'Component/Renderable';

interface ISlideMeta {
    duration?: number;
    x?: number;
    y?: number;
    offsets?: tVector4;
    easing?: tEasing;
    yoyo?: boolean;
    repeat?: number;
    returnToOriginalPos?: boolean;
    delay?: number;
    hidden?: boolean;
}

export class Slide extends AnimationClip<ISlideMeta> {
    public *execute(
        gameObject: GameObject,
        meta: ISlideMeta
    ): IterableIterator<number> {
        const {
            yoyo = false,
            repeat = 0,
            duration = 250,
            x = 0,
            y = 0,
            easing = Easing.Linear.None,
            offsets = [x, y, x, y],
            returnToOriginalPos = false,
        } = meta;

        const component =
            gameObject.getComponent(ElementComponent) ??
            gameObject.getComponent(TransformComponent);

        let slideTween;
        let originalPosition;

        if (gameObject.hasComponent(ElementComponent)) {
            originalPosition = component.offsets;
            slideTween = this.getTween(component.offsets)
                .to(offsets, duration)
                .onUpdate(offsets => {
                    component.offsets = offsets;
                });
        } else {
            originalPosition = { position: component.position.clone() };
            slideTween = this.getTween(component).to(
                { position: new Point(x, y) },
                duration
            );
        }

        if(meta.delay){
            yield* delay(meta.delay);
        }

        if(meta.hidden){
            gameObject.getComponent(Renderable). visible = true;
        }

        slideTween
            .repeat(repeat)
            .yoyo(yoyo)
            .easing(easing);

        yield* this.startTween(slideTween);

        if (returnToOriginalPos) {
            slideTween
                .to(originalPosition, duration)
                .repeat(0)
                .yoyo(false);
            yield* this.startTween(slideTween);
        }
    }
}
